// const AVATAR_PLACEHOLDER = 'https://www.gravatar.com/avatar/084e0343a0486ff05530df6c705c8bb4'

export const handleGravatar = (avatarImage: string | undefined) => {
  if (avatarImage?.includes('https://www.gravatar.com')) {
    return avatarImage ? `${avatarImage}?s=200&d=identicon` : undefined
  } else {
    return avatarImage
  }
}
